import AssignmentsPage from './AssignmentsPage';

export default { AssignmentsPage };
